import {Fragment} from 'react';
import { useDataProvider, List, Show, ReferenceArrayField, ReferenceManyField, Pagination, ArrayField, ShowBase, Button, Edit, FilterButton, useNotify, Create, required, useRecordContext, ReferenceField } from 'react-admin'
import PropTypes from 'prop-types';

import { Box, Grid } from '@mui/material';
import { Datagrid, FormDataConsumer, DateField, DateInput, TextField, AutocompleteInput, NumberField, NumberInput, ReferenceInput, SelectField, SelectInput, PasswordInput, BooleanField, EmailField, BooleanInput, SimpleShowLayout, TopToolbar, ListButton, ShowButton, SimpleForm, TextInput} from 'react-admin';
import licenseTypes from './licenseTypes';
import ShowCodesForBundle from 'components/ShowCodesForBundle'
import {PerpetualVersionList, PerpetualVersionChoices} from './perpetualVersions';
import moment from 'moment';

const LicenseBundleListActions = () => (
    <TopToolbar>
    </TopToolbar>
);

const licenseBundleFilters = [
];

export const LicenseBundleList = () => (
    <List filters={licenseBundleFilters}>
        <Datagrid rowClick="show" bulkActionButtons={false}>
            <TextField source="id"/>
            <DateField source="dateCreated" />
            <TextField source="note" />
            <NumberField source="count"/>
            <TextField source="distributorId"/>
        </Datagrid>
    </List>
);

const ExportCodes = () => {
    const record = useRecordContext();
    const dataProvider = useDataProvider();

    const handleClick = () => {
        dataProvider.getManyReference('licenses', {target: 'licenseBundleId', id: record.id, pagination: { page: 1, perPage: 100}, sort: { field: 'id', order: 'DESC' }})
        .then(resp => {
            // Creating the blob file and its url
            const csv_rows = "license-codes\n" + resp.data.map(l => l.token).join("\n")
            var blob = new Blob([csv_rows], {type: 'application/csv'}); 
            let url = window.URL.createObjectURL(blob);
            var date = moment(new Date()).format("YYYY-MM-DD");

            // // Creating the hyperlink and auto click it to start the download
            let link = document.createElement('a');
            link.href = url;
            link.download = 'codes_' + date + '.csv';
            link.click();
        })
        
    };

    return (
        <Fragment>
            <Button size="small" color="error" onClick={handleClick}><>Export Codes as CSV</></Button>
        </Fragment>
    );
};

const LicenseBundleActions = ({ basePath, data, resource }) => (
    <TopToolbar>
        <ExportCodes record={data}/>
    </TopToolbar>
);

export const LicenseBundleShow = (props) => (
    <Show {...props} actions={<LicenseBundleActions/>}>
        <SimpleShowLayout>
            <TextField source="id"/>
            <DateField source="dateCreated" />
            <TextField source="note" />
            <NumberField source="count"/>
            <ReferenceManyField reference="licenses" target="licenseBundleId" label="Licenses" perPage={100} pagination={<Pagination/>}>
                <Datagrid rowClick="show" bulkActionButtons={false}>
                    <ReferenceField source="productSkuId" reference="product-skus" />
                    <TextField source="id" /> 
                    <TextField source="token" />
                    <ReferenceField source="productSkuId" reference="product-skus" label="ProductSku" />
                    <TextField source="durationIso"/>
                    <BooleanField source="activated" FalseIcon={null}/>
                    <BooleanField source="revoked" FalseIcon={null}/>
                </Datagrid>
            </ReferenceManyField>
        </SimpleShowLayout>
    </Show>
);

const hasDuration = (subject) => {
    return !['LIFETIME', 'EDULAB', 'MUSIO_ONE', 'MUSIO_ONE_UPGRADE'].includes(subject)
}

const isMusio1 = (subject) => {
    return ['MUSIO_ONE', 'MUSIO_ONE_UPGRADE'].includes(subject)
}

const Musio1VersionInput = (props) => (
    <SelectInput label="Musio 1 Version" choices={PerpetualVersionChoices} defaultValue={PerpetualVersionList.length} {...props}/>
);

export const LicenseBundleCreate = (props) => {
    const transform = data => {
        let duration_iso = 'P';
        if (data.durationYears > 0) { duration_iso += `${data.durationYears}Y` }
        if (data.durationMonths > 0) { duration_iso += `${data.durationMonths}M` }
        if (data.durationDays > 0) { duration_iso += `${data.durationDays}D` }
        delete data.durationYears;
        delete data.durationMonths;
        delete data.durationDays;

        if (duration_iso != 'P') {  // no duration == perpetual
            data.durationIso = duration_iso;
        }
        return data
    };
    return (
        <Create {...props} transform={transform}>
            <SimpleForm>
                <ReferenceInput label="Distributor" source="distributorId" reference="distributors">
                    <SelectInput validate={required()} fullWidth/>
                </ReferenceInput>
                <TextInput source="note" label="Note (eg: Q2 2025 Resupply)" validate={required()} fullWidth/>
                <NumberInput source="count" label="Num Licenses" defaultValue={1} min={1}/>
                <BooleanField source="consignment"/>

                <ReferenceInput label="ProductSku" source="productSkuId" reference="product-skus">
                    <SelectInput validate={required()} fullWidth/>
                </ReferenceInput>
                <TextInput source="subject" defaultValue="" fullWidth/>
                <div>
                    <NumberInput source="durationYears" defaultValue={0} />
                    <NumberInput source="durationMonths" defaultValue={0} />
                    <NumberInput source="durationDays" defaultValue={0} />
                </div>
                <BooleanInput label="Are these Trial licenses?" source="isTrial" />
            </SimpleForm>
        </Create>
    );
};
